module.exports = __webpack_public_path__ + "static/media/personTwo.d4597e66.jfif";